import { useState, useEffect } from 'react'
import { HOOKS } from '../constants'

const { ERROR_MSG } = HOOKS.USE_PAGINATION

const getInitialPageCount = (itemsLength, step) => {
  if (itemsLength > step) {
    return step
  }

  return itemsLength
}

const usePagination = ({ items: allItems, step: initialStep } = {}) => {
  try {
    if (!Array.isArray(allItems)) {
      throw ERROR_MSG.ITEMS_TYPE
    } else if (!Number.isInteger(initialStep)) {
      throw ERROR_MSG.STEP_TYPE
    } else if (initialStep <= 0) {
      throw ERROR_MSG.STEP_VALUE
    }

    const [step, setStep] = useState(initialStep)
    const [pageCount, setPageCount] = useState(
      getInitialPageCount(allItems.length, initialStep)
    )

    const remainingItems = allItems.length - pageCount
    const items = allItems.slice(0, pageCount)

    useEffect(
      () => {
        if (remainingItems < step) {
          setStep(remainingItems)
        }
      },
      [remainingItems, step]
    )

    const nextPage = () => {
      if (remainingItems > 0) {
        const newPageCount = pageCount + step
        setPageCount(newPageCount)
      }
    }

    return {
      items,
      step,
      nextPage,
      remainingItems,
    }
  } catch (err) {
    throw Error(err)
  }
}

export default usePagination
